/**
 * @file recover the focus after views being updated
 */
import { DeterministicView } from './deterministic-view';

// The focus state, keep track of the focused view and element
const focus = {
  // The view having focus
  view: null,

  // The data-focus-id of the focused element
  id: null,
};

// Before rendering a new animation frame, update the focus state.
DeterministicView.eventEmitter.on('willRenderFrame', () => {
  const { activeElement } = document;

  focus.view = DeterministicView.getViewForElement(activeElement);
  focus.id = (activeElement && activeElement.dataset && activeElement.dataset.focusId) || null;
});

// After rendering an animation frame, locate the element described by the focus
// state, then activate it
DeterministicView.eventEmitter.on('didRenderFrame', () => {
  if (DeterministicView.isValid(focus.view) && focus.id) {
    const selFocus = `[data-focus-id=${JSON.stringify(focus.id)}]`;
    const elFocus = focus.view.$(selFocus).get(0);

    if (elFocus && elFocus !== document.activeElement) {
      elFocus.focus();
    }
  }
});
